// libs
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './styles.scss';

function TableSpecs({ specs }) {
  return (
    <dl className="table-specs">
      {specs.map(({ name, value }) =>
        <div className="table-specs__spec" key={`spec-${name}-${value}`}>
          <dt>{name}</dt>
          <dd>
            { typeof value === 'object' && value.length ?
              value.map((val) => (
                <div key={val}>{val}</div>
              ))
              : value
            }
          </dd>
        </div>,
      )}
    </dl>
  );
}

TableSpecs.propTypes = {
  specs: PropTypes.array.isRequired,
};

export default TableSpecs;



// WEBPACK FOOTER //
// ./src/app/components/tools/wysiwyg/parts/tableSpecs/TableSpecs.js